import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import Profile from "./Profile";
import Security from "./Security";
import { verifyToken } from "../../utils/helpers";
import { translations } from "../../utils/constants";

const Settings = ({ language }) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    const [activeTab, setActiveTab] = useState("profile");

    useEffect(() => {
        verifyToken(history, dispatch);
        if (location.state?.activeTab) {
            setActiveTab(location.state.activeTab); 
        }
    }, [location.state, history, dispatch]);

    return (
        <div className="main-container">
            <div className="main-inner-container">
                <div className="profile-tab">
                    <h1 className="main-heading setting">
                        {translations[language]?.settingHeading}
                    </h1>

                    <div className="profile-tab-inner-div">
                        <div className="tabs-header">
                            <button
                                className={`tab-button ${activeTab === "profile" ? "tab-active" : ""
                                    }`}
                                onClick={() => setActiveTab("profile")}
                            >
                                {translations[language]?.profileSetting}
                            </button>
                            <button
                                className={`tab-button ${activeTab === "security" ? "tab-active" : ""
                                    }`}
                                onClick={() => setActiveTab("security")}
                            >
                                {translations[language]?.securityfleSetting}
                            </button>
                        </div>

                        <div className="tabs-content">
                            {activeTab === "profile" && <Profile language={language} />}
                            {activeTab === "security" && <Security language={language} />}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Settings;
